import { css } from 'styled-components';
export const interactiveTransition = css `
  transition-property: background, border, color, box-shadow, outline, opacity;
  transition-duration: 0.25s;
  transition-timing-function: ease;

  [data-icon='falcon'] {
    transition-property: inherit;
    transition-duration: inherit;
    transition-timing-function: inherit;
  }
`;
